// @flow
import ResourceFill from 'components/ResourceFill'
import * as React from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { ContextTabletMode } from 'utils/ContextTabletMode'
import { ZentakeContext } from 'utils/ZentakeContext'

function TabletModeFill(): React.Node {
  const { sessionId, mode, resourceType } = useParams()
  const { privateFetchInsuranceCompanies } = React.useContext(ZentakeContext)

  const { sessions, setSessions } = React.useContext(ContextTabletMode)

  useEffect(() => {
    privateFetchInsuranceCompanies()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!['client', 'office'].includes(mode)) {
    return null
  }

  if (!['f', 'p'].includes(resourceType)) {
    return null
  }

  return (
    <ResourceFill
      isTablet
      isPacket={resourceType === 'p'}
      mode={mode}
      sessionId={sessionId}
      sessions={sessions}
      setSessions={setSessions}
    />
  )
}

export default TabletModeFill
